import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from 'ui-components/common/Link';
import React from 'react';

interface KeywordProps {
  className?: string;
  color?: string;
  keyword: string;
}

export const Keyword = ({ className, color = Color.Gray200, keyword }: KeywordProps) => (
  <StyledKeywordLink href={`/search?q=${encodeURIComponent(`#${keyword}`)}`} className={className} color={color}>
    {keyword}
  </StyledKeywordLink>
);

const StyledKeywordLink = styled(Link)(
  ({ color }: { color: string }) => css`
    cursor: pointer;
    display: inline-block;
    padding: 1px 4px;
    color: ${Color.Gray600};
    background-color: ${color};
    border-radius: 4px;
    ${Typography.XXXSmall};
  `,
);
